var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319793"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2330",
    cx: 26.8968,
    cy: 27.0257,
    r: 25.7267,
    fill: "MainStyle.$theme-btn",
    fillOpacity: 0.12,
    stroke: "MainStyle.$theme-btn",
    strokeWidth: 0.887127
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427319784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.6311 20.084H18.7119C17.44 20.084 16.8036 20.084 16.302 20.2873C15.6331 20.5583 15.102 21.0785 14.825 21.7328C14.6172 22.2235 14.6172 22.8457 14.6172 24.0899C16.8786 24.0899 18.7119 25.8827 18.7119 28.095C18.7119 30.3072 16.8786 32.1009 14.6172 32.1009C14.6172 33.3452 14.6172 33.9673 14.825 34.4581C15.102 35.1124 15.6331 35.6321 16.302 35.9032C16.8036 36.1065 17.44 36.1066 18.7119 36.1066H29.6311M29.6311 20.084H35.0906C36.3626 20.084 36.9985 20.084 37.5002 20.2873C38.1691 20.5583 38.7003 21.0785 38.9774 21.7328C39.1852 22.2235 39.1852 22.8457 39.1852 24.0899C36.9238 24.0899 35.0906 25.883 35.0906 28.0953C35.0906 30.3075 36.9238 32.1009 39.1852 32.1009C39.1852 33.3452 39.1852 33.9673 38.9774 34.4581C38.7003 35.1124 38.1691 35.6321 37.5002 35.9032C36.9985 36.1065 36.3626 36.1066 35.0906 36.1066H29.6311M29.6311 20.084V36.1066",
    stroke: "MainStyle.$theme-btn",
    strokeWidth: 1.33069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/dashboardicon.fe7778952287cd238841faab0c55db9e.svg";
export { ForwardRef as ReactComponent };